finderApp.directive('niProductLink', function () {
    "use strict";

    return {
        restrict: 'EA',
        scope: {
            niProductLink: '=',
            href: '@'
        },
        link: function (scope, element, attr) {
            angular.element(element).on('click', function (e) {
                e.preventDefault();
                scope.onClick();
            });
        },
        controller: ['$scope', '$q', 'productService', function ($scope, $q, productService) {
            $scope.onClick = function (event) {

                var product = $scope.niProductLink;

                return productService.getReferencePrice(product)
                    .then(function (data) {

                        var promises = [];

                        promises.push(Track.event('funnel', {
                            step: 'finder',
                            products: [{
                                productId: product.sku,
                                productName: product.title,
                                price: data.referencePrice,
                                category: product.brand,
                                subCategory: product.category
                            }]
                        }));

                        promises.push(Track.ecommerceEvent('Clicked', {
                            click: {
                                actionField: {list: 'Product Finder'},
                                products: [{
                                    name: product.title,
                                    id: product.sku,
                                    price: data.referencePrice,
                                    brand: product.brand,
                                    category: product.category
                                }]
                            }
                        }));

                        if (data.personalizedPrice) {
                            promises.push(Track.analyticsEvent('Product', 'Clicked personalized price', product.title));
                        }

                        return $q.all(promises);
                    })
                    .then(function() {
                        window.location.href = $scope.href;
                    });

            };

        }]
    };
});